import { createAction, props } from '@ngrx/store';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';

export const loadSaldoReportStart = createAction('ZEITERFASSUNG::LOAD_SALDOREPORT_START', props<{userId: number}>());
export const loadSaldoReportSucceeded = createAction(
    'ZEITERFASSUNG::LOAD_SALDOREPORT_SUCCEEDED',
    props<{ item: SaldoItem }>(),
);
export const loadSaldoReportFailed = createAction('ZEITERFASSUNG::LOAD_SALDOREPORT_FAILED', props<{ error: Error }>());
